var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 36,
    strokeDashoffset: 36,
    d: "M12 7c2.76 0 5 2.24 5 5c0 2.76 -2.24 5 -5 5c-2.76 0 -5 -2.24 -5 -5c0 -2.76 2.24 -5 5 -5"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    dur: "0.5s",
    values: "36;0"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 2,
    strokeDashoffset: 2,
    d: "M12 19v1M19 12h1M12 5v-1M5 12h-1",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0.6s",
    dur: "0.2s",
    values: "M12 19v1M19 12h1M12 5v-1M5 12h-1;M12 21v1M21 12h1M12 3v-1M3 12h-1"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.6s",
    dur: "0.2s",
    values: "2;0"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    attributeName: "opacity",
    begin: "0.6s",
    to: 1
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "30s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 12 12;360 12 12"
  })), /*#__PURE__*/React.createElement("path", {
    strokeDasharray: 2,
    strokeDashoffset: 2,
    d: "M17 17l0.5 0.5M17 7l0.5 -0.5M7 7l-0.5 -0.5M7 17l-0.5 0.5",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0.8s",
    dur: "0.2s",
    values: "M17 17l0.5 0.5M17 7l0.5 -0.5M7 7l-0.5 -0.5M7 17l-0.5 0.5;M18.5 18.5l0.5 0.5M18.5 5.5l0.5 -0.5M5.5 5.5l-0.5 -0.5M5.5 18.5l-0.5 0.5"
  }), /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "stroke-dashoffset",
    begin: "0.8s",
    dur: "0.2s",
    values: "2;0"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    attributeName: "opacity",
    begin: "0.8s",
    to: 1
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    dur: "30s",
    repeatCount: "indefinite",
    type: "rotate",
    values: "0 12 12;360 12 12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.ea3b610f7df2e5e1ee17ca9640288087.svg";
export { ForwardRef as ReactComponent };